export default function() {
	if(circleLoaderElement) {
		return circleLoaderElement.clone();
	}
	else {
		return circleLoaderElement = $('#circle_loader_element').remove().removeAttr('id').removeClass('template');
	}
};

let circleLoaderElement = null;